import React, { } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fonts, glyphs, useMediaQuery } from '../../../../Styles';
import { ButtonList, NewInput } from '../../../../Components';
import { ButtonTypes, NewFieldStyles } from '../../../../Definitions';

// TODO
import Setting from '../../../../Components/Settings/setting';

export default function UserAdministration() {
  const { t } = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 570px)`);
  const responsiveBox = useMediaQuery(`(max-width: 1420px)`);

  return (  <div style={{display: "flex", gap: "20px", alignItems: mobileXs ? "center" : "end", justifyContent: "center", flexDirection: "column", width: !responsiveBox ? "1050px" : "100%"}}>
    <Setting startEnhancer={glyphs.User({size: "25px"})} header={t("globalSettingsPages.globalSettings.userManagement", {defaultValue: "user management"})} content={
      <>
        <div style={{display: "flex", flexWrap: "wrap", gap: "5px", justifyContent: mobileXs ? "center" : "start"}}>
          <NewInput 
            placeholder={t("user.email", {defaultValue: "email"})} 
            fieldOverrides={{
              fieldStyle: NewFieldStyles.greyTertiary
            }}
            isDisabled
          />
          <div style={{display: "flex", flexDirection: "row", gap: "5px"}}>
            <ButtonList
              contents={[t("buttons.add", {defaultValue: "add"}), t("globalSettingsPages.globalSettings.remove", {defaultValue: "remove"})]}
              buttonType={ButtonTypes.textButton}
              overrides={{
                baseButton: { width:"fit-content", backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px"},
                contentStyles: {color: colors.greyDarkPrimary, textShadow: "none", ...fonts.fontSize4},
                hoverStyles: {backgroundColor: colors.greyLightSecondary}
              }}
              disabled={[true, true]}
            />
          </div>
        </div>
        <div style={{height: "2px", backgroundColor: colors.greyLightPrimary, width: "100%", margin: "15px 0"}}/>
      </>
    }/>
  </div> );
}